import React, { useEffect } from "react";
import Header from "../components/Header";

export default function ForgotPasswordSentPage({ navigate, user, onLogin, onAccount, showBlog = true, onShareSite }) {
  useEffect(() => {
    document.title = "СоцПлан | Ссылка отправлена";
  }, []);

  return (
    <div className="min-h-screen bg-slate-100 py-6 md:py-10">
      <div className="mx-auto w-full max-w-3xl rounded-2xl border bg-white shadow-md">
        <Header
          navigate={navigate}
          user={user}
          onLogin={onLogin}
          onAccount={onAccount}
          showBlog={showBlog}
          onShareSite={onShareSite}
        />
        <section className="px-5 md:px-6 py-12 text-center">
          <h1 className="text-2xl font-semibold">Если адрес существует, письмо уже в пути</h1>
          <p className="mt-4 text-slate-600">
            Мы отправили ссылку для сброса пароля на указанный e-mail. Проверьте входящие и папку «Спам».
          </p>
          <div className="mt-8 flex items-center justify-center gap-3">
            <button
              className="inline-flex h-11 items-center justify-center rounded-lg bg-blue-600 px-6 font-semibold text-white shadow hover:bg-blue-700"
              onClick={() => navigate("home")}
            >
              На главную
            </button>
            <button
              className="inline-flex h-11 items-center justify-center rounded-lg border border-slate-200 px-6 font-semibold text-slate-700 hover:border-slate-300"
              onClick={() => navigate("forgotPassword")}
            >
              Указать другой e-mail
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
